export const environment = {
  env: 'PROD',
  production: true,
  // serverBaseUrl: 'https://agent-api.herokuapp.com',
  // serverUrl: 'https://agent-api.herokuapp.com/v1'
  serverBaseUrl: 'https://beta-pip-api.dowc.com',
  serverUrl: 'https://beta-pip-api.dowc.com/v1',
  s3Url: 'https://dowc-pipqa.s3.amazonaws.com',
  siteKey: '6LcHBxAcAAAAAM5lFam36od_3C_HN4jsL8gxaejL',
  devServiceURL: 'https://devservices.dowc.com',
  scasUrl: 'http://pip-scas.dowc.com',
  // serverBaseUrl: 'https://pip-api.dowc.com',
  // serverUrl: 'https://pip-api.dowc.com/v1',
  // s3Url: 'https://dowc-pip.s3.amazonaws.com',
  // siteKey: '6LdoHzMcAAAAANhCct28ycJyWCI7f6INwlZIZdqr',
  // devServiceURL: 'https://devservices.dowc.com'
};
